// src/hooks/useOtpTimer.js
import { useEffect, useState } from "react";

const useOtpTimer = (initialTime = 60) => {
  const [timer, setTimer] = useState(0);

  // Start timer
  const startTimer = () => {
    setTimer(initialTime);
  };

  // Stop timer manually if needed
  const stopTimer = () => {
    setTimer(0);
  };

  // Countdown logic
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return { timer, startTimer, stopTimer };
};

export default useOtpTimer;
